export default "__VITE_ASSET__DXYeUgkq__"